import React, { useState } from "react";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { Log, sendDataWithPost } from "../../../services/services";
import { showSuccessMsg } from "../../../utils/toast";
import { LoadingButton } from "@mui/lab";
import { styles } from "../../../utils/styles";

const PublishDateDialog = ({ queryPage, selectedId, open, handleCloseDialog }) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    handleCloseDialog();
  }

  const submitPublishDate = async () => {
    const payload = { pk: selectedId };
    const url = "/admins/product_update/publish/";
    setLoading(true);
    Log.info(`Click button [Submit] - Publish Product Update by Id: ${selectedId}`)
    await sendDataWithPost(url, payload, null, null, (res) => {
      showSuccessMsg(res.data?.detail);
      handleCloseDialog();
      queryPage();
    });
    setLoading(false);
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {"Are you sure you want to publish date this Product Update?"}
      </DialogTitle>
      <DialogActions>
        <LoadingButton variant="outlined" onClick={handleClose} disabled={loading}>
          Cancel
        </LoadingButton>
        <LoadingButton variant="contained" onClick={submitPublishDate} loading={loading} sx={{ ...styles.customButton }}>
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default PublishDateDialog;
